<div class="h-screen max-w-screen ">
      <router-outlet></router-outlet>
</div>
